<template>
  <div>
    <van-nav-bar
      left-text="返回"
      left-arrow
      :class="[$store.state.style]"
      @click-left="onClickLeft"
    />
    <div :class="['main', $store.state.style]" ref="main">
      <iframe
        width="100%"
        height="100%"
        ref="iframe"
        :src="src"
        frameborder="0"
      ></iframe>
      <Card
        v-for="item in list"
        :key="item.index"
        :data="item"
        :class="['card', $store.state.style]"
        @click.native="submit(item)"
      />
    </div>
  </div>
</template>

<script>
import { NavBar, Toast } from 'vant'
import { getSrvHeadlinesRandom } from '@/api'
import Card from '@/components/Card'
export default {
  components: {
    [NavBar.name]: NavBar,
    Card
  },
  data() {
    return {
      src: '',
      list: []
    }
  },
  created() {
    this.src = `http://cdn.mktcircle.cn/news_common/${this.$route.params.id}.html`
    this.newsList()
  },
  methods: {
    newsList() {
      getSrvHeadlinesRandom({ typeId: 0 }).then(res => {
        if (res.code === 200) {
          this.list = res.data
        } else {
          Toast.fail(res.message)
        }
      })
    },
    handleFrameMessage(event) {
      const msgData = event.data
      switch (msgData.cmd) {
        case 'returnHeight':
          if (this.$refs.iframe) {
            this.$refs.iframe.height = msgData.params.height
          }
          break
      }
    },
    // 跟新浏览内容
    submit(val) {
      // console.log(val)
      // this.$refs.main.scrollTop = 0
      // this.data = val
      this.$router.push(`/new/${val.contId}`)
      location.reload()
    },
    // 返回首页
    onClickLeft() {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .van-nav-bar.styleB {
  background-color: #c23a2b;
  .van-nav-bar__text {
    color: #fff;
  }
  .van-icon {
    color: #fff;
  }
  .van-nav-bar__title {
    color: #fff;
  }
}
/deep/ .van-nav-bar.styleC {
  background-color: #17161b;
  .van-nav-bar__text {
    color: #fff;
  }
  .van-icon {
    color: #fff;
  }
  .van-nav-bar__title {
    color: #fff;
  }
}
.main {
  height: calc(100vh - 46px);
  box-sizing: border-box;
  overflow-y: auto;
  .card {
    margin: 0 10px;
  }
  .card.styleB {
    margin-top: 10px;
  }
}
.main.styleC {
  background-color: #f6f6f6;
  .card.styleC {
    margin-top: 8px;
  }
}
.main::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
</style>
